export enum AuthenticationActions {
  SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO',
  SET_USER_INFO_OBJECT = "SET_USER_INFO_OBJECT",
  SET_LIMITS_OBJECT = "SET_LIMITS_OBJECT",
  SET_INITIAL_LOAD_COMPLETE = 'SET_INITIAL_LOAD_COMPLETE',
}
